import React, { Component } from 'react'
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import { clientname, currentTenant, dataaccess, financialyearend, financialyearstart, logo, thousandsdisplay, userid, currency, theme } from '../../Common/Credentials.js'
import moment from 'moment'
import { spin } from '../../Common/NewLoader.jsx'
import SalesServices from '../SalesServices.js'
import { salesid } from '../../Common/Permissions.js'
import { NumericFormat } from 'react-number-format';
import { FormControlLabel, Grid, Tooltip } from "@mui/material";
import IOSSwitch from '../../CommonComponents/IOSSwitch.js'
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"
import AssetsService from '../../AssetManagement/AssetsService.js'
import UsercustomerService from '../../Masters/Usercustomers/UsercustomerService.js'
import { TextField, MenuItem } from '@mui/material';
// Import icons
import EditIcon from "../../images/Icons/edit.png";
import ViewIcon from "../../images/Icons/preview.png";
import RecurringIcon from "../../images/Icons/recurring-invoice.png"
import UpArrow from "../../images/Icons/up-arrow.png";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Button from '../../NewUI/NewComponents/Button.jsx';

// Import CSV export library
import { utils, writeFile } from 'xlsx';

// Import CSS
import '../../NewUI/NewUI.css';
import Breadcrumb from '../../NewUI/NewComponents/Breadcrumb.jsx';
import TabSwitch from '../../NewUI/NewComponents/TabSwitch.jsx';
import { Calendar } from 'lucide-react';

const TabButton = ({ active, onClick, children }) => (
  <fieldset
    onClick={onClick}
    className={`UI-tab-button ${active ? "UI-active-tab" : "UI-inactive-tab"}`}
    style={{
      cursor: "pointer",
      transition: "all 0.3s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      padding: "8px 16px",
      fontSize: "0.8rem",
      fontWeight: 500,
      textWrap: "nowrap",
    }}
  >
    {children}
    <img
      src={UpArrow}
      alt="Up Arrow"
      className="UI-tab-arrow"
      style={{
        transform: active ? "rotate(30deg)" : "rotate(0deg)",
      }}
    />
  </fieldset>
);

class InvoiceTable extends Component {
  constructor(props) {
    super(props)
    const saved = (() => {
      try {
        const tenantKey = currentTenant ? `_${currentTenant}` : '';
        const data = sessionStorage.getItem(`invoice_table_state${tenantKey}`);
        return data ? JSON.parse(data) : null;
      } catch (e) {
        return null;
      }
    })();

    this.state = {
      AllInvoice: [],
      Invoice: [],
      pendingInvoice: [],
      CompletedInvoice: [],
      CancelledInvoice: [],
      proformaInvoice: [],
      proformaInvoiceCompleted: [],
      activeTab: saved?.activeTab || "all",
      loading: false,
      active: saved ? (saved.active ?? false) : false,
      all: saved ? (saved.all ?? true) : true,
      pending: saved ? (saved.pending ?? false) : false,
      comp: saved ? (saved.comp ?? false) : false,
      cancel: saved ? (saved.cancel ?? false) : false,
      type: this.props.location.state?.type || saved?.type || "Tax Invoice",
      rentInvoice: [],
      soldInvoice: [],
      rent: saved ? (saved.rent ?? true) : true,
      sales: saved ? (saved.sales ?? false) : false,
      usercustomers: [],
      hovered: null,
      isActionHovered: null,
      searchTerm: saved?.searchTerm || "",
      showSearch: saved?.showSearch || false,
      isMobile: window.innerWidth <= 768,
      currentView: saved?.currentView || 'list',
      selectedInvoice: null,
      savedSelectedInvoiceId: saved?.selectedInvoiceId || null,
      lastViewedInvoiceId: saved?.lastViewedInvoiceId || null,
      hasScrolledToLastViewed: false,
      hoveredRow: null,
      filteredData: [],
      filteredSidebarData: [],
      currentPage: saved?.currentPage || 1,
      itemsPerPage: saved?.itemsPerPage || 20,
      hasScrolledToSelected: false,
      fromdate: saved?.fromdate ? moment(saved.fromdate) : moment().subtract(7, "days"),
      todate: saved?.todate ? moment(saved.todate) : moment(),
      sortConfig: saved?.sortConfig || { key: 'createdAt', direction: 'desc' },
      dateFilterApplied: saved?.dateFilterApplied || false,
      initialLoad: true,
      exportDropdownOpen: false
    }

    this.saveTableState = () => {
    try {
      const tenantKey = currentTenant ? `_${currentTenant}` : '';
      const stateToSave = {
        currentPage: this.state.currentPage,
        itemsPerPage: this.state.itemsPerPage,
        searchTerm: this.state.searchTerm,
        showSearch: this.state.showSearch,
        activeTab: this.state.activeTab,
        type: this.state.type,
        all: this.state.all,
        active: this.state.active,
        pending: this.state.pending,
        comp: this.state.comp,
        cancel: this.state.cancel,
        rent: this.state.rent,
        sales: this.state.sales,
        dateFilterApplied: this.state.dateFilterApplied,
        fromdate: this.state.fromdate ? this.state.fromdate.toISOString() : null,
        todate: this.state.todate ? this.state.todate.toISOString() : null,
        sortConfig: this.state.sortConfig,
        currentView: this.state.currentView,
        selectedInvoiceId: this.state.selectedInvoice?.invid || this.state.savedSelectedInvoiceId || null,
        lastViewedInvoiceId: this.state.lastViewedInvoiceId || null,
      };
      sessionStorage.setItem(`invoice_table_state${tenantKey}`, JSON.stringify(stateToSave));
    } catch (e) {
      console.warn("Failed to save invoice table state", e);
    }
  };
    this.handleResize = this.handleResize.bind(this);
    this.refreshSalesorder = this.refreshSalesorder.bind(this);
    this.pdf = this.pdf.bind(this);
    this.handlePendingChange = this.handlePendingChange.bind(this);
    this.handleAllChange = this.handleAllChange.bind(this);
    this.handleActiveChange = this.handleActiveChange.bind(this);
    this.handlecompChange = this.handlecompChange.bind(this);
    this.handleCancelChange = this.handleCancelChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.formatCurrency = this.formatCurrency.bind(this);
    this.formatCurrencyAsString = this.formatCurrencyAsString.bind(this);
    this.getCurrentData = this.getCurrentData.bind(this);
    this.renderTable = this.renderTable.bind(this);
    this.renderTypeTabs = this.renderTypeTabs.bind(this);
    this.renderStatusTabs = this.renderStatusTabs.bind(this);
    this.handleInvoiceClick = this.handleInvoiceClick.bind(this);
    this.handleBackToList = this.handleBackToList.bind(this);
    this.renderListView = this.renderListView.bind(this);
    this.renderDetailView = this.renderDetailView.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleItemsPerPageChange = this.handleItemsPerPageChange.bind(this);
    this.renderPagination = this.renderPagination.bind(this);
    this.sortData = this.sortData.bind(this);
    this.getSortedData = this.getSortedData.bind(this);
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
    this.handleApplyDateFilter = this.handleApplyDateFilter.bind(this);
    this.handlePreviousMonth = this.handlePreviousMonth.bind(this);
    this.handleClearFilter = this.handleClearFilter.bind(this);
    this.exportPDF = this.exportPDF.bind(this);
    this.exportCSV = this.exportCSV.bind(this);
    this.toggleExportDropdown = this.toggleExportDropdown.bind(this);
    this.closeExportDropdown = this.closeExportDropdown.bind(this);
    this.sidebarRef = React.createRef();
    this.scrollTimeout = null;
    this.exportRef = React.createRef();
  }

  // ========== NEW AMOUNT PRIORITIZATION HELPERS ==========
  // Replace existing methods with:
  getPrimaryAmount = (item, field, ccField) => {
    // Always return the invoice currency amount (origVal)
    return item[field] != null ? item[field] : 0;
  }

  getFallbackAmount = (item, field, ccField) => {
    // Return the converted amount if it exists, otherwise null
    return item[ccField] != null ? item[ccField] : null;
  }
  // =======================================================

  // Sort indicator component
  SortIndicator = ({ columnKey }) => {
    if (this.state.sortConfig.key !== columnKey) {
      return <i className="fa fa-sort UI-sort-icon" />;
    }
    return this.state.sortConfig.direction === 'asc'
      ? <i className="fa fa-sort-up UI-sort-icon UI-sort-active" />
      : <i className="fa fa-sort-down UI-sort-icon UI-sort-active" />;
  }

  // Sorting function
  sortData(key) {
    let direction = 'asc';
    if (this.state.sortConfig.key === key && this.state.sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    this.setState({ sortConfig: { key, direction } });
  }

  getSortedData(data) {
    if (!this.state.sortConfig.key) return data;

    return [...data].sort((a, b) => {
      let aValue, bValue;

      switch (this.state.sortConfig.key) {
        case 'customer':
          aValue = a.customer || '';
          bValue = b.customer || '';
          break;
        case 'custominvid':
          aValue = a.custominvid || '';
          bValue = b.custominvid || '';
          break;
        case 'createdAt':
          aValue = new Date(a.createdAt).getTime();
          bValue = new Date(b.createdAt).getTime();
          break;
        case 'totalinvoice':
          // Use prioritized amount
          aValue = Number(this.getPrimaryAmount(a, 'totalinvoice', 'cctotalinvoice')) || 0;
          bValue = Number(this.getPrimaryAmount(b, 'totalinvoice', 'cctotalinvoice')) || 0;
          break;
        case 'paid':
          aValue = Number(a.paid) || 0;
          bValue = Number(b.paid) || 0;
          break;
        case 'due':
          aValue = Number(a.due) || 0;
          bValue = Number(b.due) || 0;
          break;
        case 'taxamount':
          aValue = Number(this.getPrimaryAmount(a, 'taxamount', 'cctaxamount')) || 0;
          bValue = Number(this.getPrimaryAmount(b, 'taxamount', 'cctaxamount')) || 0;
          break;
        default:
          aValue = a[this.state.sortConfig.key] || '';
          bValue = b[this.state.sortConfig.key] || '';
      }

      if (aValue < bValue) {
        return this.state.sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return this.state.sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  escapeRegex(string) {
    if (!string) return '';
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlightSearchText(text, searchTerm) {
    if (!searchTerm?.trim() || !text) return text;

    const rawText = String(text);
    const escapedSearchTerm = this.escapeRegex(searchTerm);

    if (escapedSearchTerm.length > 50) {
      return rawText;
    }

    try {
      const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
      const parts = rawText.split(regex);

      return parts.map((part, index) =>
        regex.test(part)
          ? React.createElement('mark', {
            key: index,
            className: 'UI-search-highlight'
          }, part)
          : part
      );
    } catch (error) {
      console.warn('Regex error in search:', error);
      return rawText;
    }
  }

  formatCurrencyAsString(value) {
    if (value === null || value === undefined) return '0';
    const numericValue = typeof value === 'object' && value.parsedValue !== undefined ? value.parsedValue : value;

    return new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numericValue);
  }

  getTabMatchCounts() {
    const { searchTerm } = this.state;

    if (!searchTerm.trim()) {
      return {
        all: this.state.AllInvoice.length,
        active: this.state.Invoice.length,
        pending: this.state.pendingInvoice.length,
        comp: this.state.CompletedInvoice.length,
        cancel: this.state.CancelledInvoice.length,
        rent: this.state.rentInvoice.length,
        sales: this.state.soldInvoice.length,
        proformaActive: this.state.proformaInvoice.length,
        proformaComp: this.state.proformaInvoiceCompleted.length,
      };
    }

    const countMatches = (data) => {
      const cleanSearch = searchTerm.replace(/[^\w₹$€]/g, '').toLowerCase();

      return data.filter((item) => {
        const checkFields = [
          item.customer,
          item.custominvid,
          item.customsoid,
          item.totalinvoice?.toString(),
          item.cctotalinvoice?.toString(),
          item.paid?.toString(),
          item.due?.toString(),
          item.currency,
          item.taxamount?.toString(),
          item.cctaxamount?.toString(),
        ];

        return checkFields.some((field) => {
          if (field === undefined || field === null) return false;

          const raw = String(field);
          const cleanField = raw.replace(/[^\w₹$€]/g, '').toLowerCase();

          return (
            cleanField.includes(cleanSearch) ||
            raw.toLowerCase().includes(searchTerm.toLowerCase())
          );
        });
      }).length;
    };

    return {
      all: countMatches(this.state.AllInvoice),
      active: countMatches(this.state.Invoice),
      pending: countMatches(this.state.pendingInvoice),
      comp: countMatches(this.state.CompletedInvoice),
      cancel: countMatches(this.state.CancelledInvoice),
      rent: countMatches(this.state.rentInvoice),
      sales: countMatches(this.state.soldInvoice),
      proformaActive: countMatches(this.state.proformaInvoice),
      proformaComp: countMatches(this.state.proformaInvoiceCompleted),
    };
  }

  formatCurrency(value, searchTerm = null) {
    if (value === null || value === undefined) return '0';

    const numericValue = typeof value === 'object' && value.parsedValue !== undefined ? value.parsedValue : value;

    const prefix = currency === "INR" ? "₹ " : currency === "USD" ? "$ " : currency + " ";

    const formattedNumber = Number(numericValue).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    const fullFormattedString = `${prefix}${formattedNumber}`;

    if (searchTerm) {
      return this.highlightSearchText(fullFormattedString, searchTerm);
    }

    return (
      <NumericFormat
        displayType="text"
        value={numericValue}
        decimalScale={2}
        fixedDecimalScale={true}
        thousandSeparator={true}
        thousandsGroupStyle={thousandsdisplay}
        prefix={prefix.trim()}
      />
    );
  }

  formatCurrencyWithConversion(amount, ccamount, invCurrency, convRate, mainCurrency, color, searchTerm) {
    const numAmount = Number(amount || 0);
    const conversionRate = Number(convRate || 1);

    const mainPrefix = mainCurrency === 'INR' ? '₹ ' : mainCurrency === 'USD' ? '$ ' : mainCurrency + ' ';
    const formattedMain = `${mainPrefix}${numAmount.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

    const convertedAmount = ccamount ? ccamount : numAmount * conversionRate;
    const invPrefix = invCurrency === 'INR' ? '₹ ' : invCurrency === 'USD' ? '$ ' : invCurrency + ' ';
    const formattedConverted = `${invPrefix}${convertedAmount.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

    if (mainCurrency !== invCurrency && numAmount > 0) {
      return (
        <div style={{ textAlign: 'right', color }}>
          <div>{this.highlightSearchText(formattedMain, searchTerm)}</div>
          <div style={{ fontSize: '0.72rem', color: '#888' }}>
            {this.highlightSearchText(formattedConverted, searchTerm)}
          </div>
        </div>
      );
    }

    return (
      <span style={{ color }}>
        {this.highlightSearchText(formattedMain, searchTerm)}
      </span>
    );
  }

  handleResize() {
    const isMobile = window.innerWidth <= 768;
    this.setState({ isMobile });
    if (!isMobile) {
      this.setState({ showSearch: false });
    }
  }

  componentDidMount() {
    if (window.innerWidth <= 768) {
      this.setState({ showSearch: true });
    }
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('mousedown', this.handleClickOutside);

    if (userid === undefined) {
      window.confirm('Your Session is Lost: Please login Back to resume')
      this.props.navigate(`/`)
    }
    UsercustomerService.GetUserCustomersbyUser(userid).then((res) =>
      this.setState({ usercustomers: res.data === '' || res.data === undefined ? [] : res.data.customers.split(",") })
    )
    this.setState({ loading: true })
    this.refreshSalesorder(this.state.dateFilterApplied)
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.currentView === 'detail' &&
      this.state.selectedInvoice &&
      this.sidebarRef.current &&
      !this.state.hasScrolledToSelected) {

      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }

      this.scrollTimeout = setTimeout(() => {
        const selectedElement = this.sidebarRef.current.querySelector(`[data-invoice-id="${this.state.selectedInvoice.invid}"]`);
        if (selectedElement) {
          selectedElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          this.setState({ hasScrolledToSelected: true });
        }
      }, 100);
    }

    if (this.state.lastViewedInvoiceId && !this.state.hasScrolledToLastViewed && this.state.currentView === 'list' && this.state.filteredData.length > 0) {
      const el = document.querySelector(`[data-row-invoice-id="${this.state.lastViewedInvoiceId}"]`);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        this.setState({ hasScrolledToLastViewed: true });
      }
    }

    if (prevState.currentView !== this.state.currentView && this.state.currentView === 'list') {
      this.setState({ hasScrolledToSelected: false });
    }

    if (prevState.selectedInvoice?.invid !== this.state.selectedInvoice?.invid) {
      this.setState({ hasScrolledToSelected: false });
    }

    // Only reset date filter when switching TYPE tabs, not status tabs
    if (prevState.type !== this.state.type) {
      this.setState({
        fromdate: moment().subtract(7, "days"),
        todate: moment(),
        dateFilterApplied: false
      }, () => {
        if (!this.state.initialLoad) {
          this.refreshSalesorder();
        }
      });
    }
  }

  componentWillUnmount() {
    this.saveTableState();
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('mousedown', this.handleClickOutside);
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
  }

  handleClickOutside = (event) => {
    if (this.exportRef.current && !this.exportRef.current.contains(event.target)) {
      this.setState({ exportDropdownOpen: false });
    }
  };

  refreshSalesorder(useDateFilter = false) {
    let datadao = {
      tenantid: currentTenant,
      startdate: useDateFilter && this.state.dateFilterApplied ? this.state.fromdate : financialyearstart,
      enddate: useDateFilter && this.state.dateFilterApplied ? this.state.todate : financialyearend,
      userid: userid,
      dataaccess: dataaccess
    }

    // Set initial load to false after first load
    if (this.state.initialLoad) {
      this.setState({ initialLoad: false });
    }

    this.setState({ loading: true });

    // Call all APIs at once for all types
    this.fetchTaxInvoiceData(datadao);
    this.fetchProformaInvoiceData(datadao);
    this.fetchAssetInvoiceData(datadao);
  }

  fetchTaxInvoiceData(datadao) {

    SalesServices.GetSalesInvoices(datadao).then(response => {
      this.setState({
        AllInvoice: response.data.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1)
          .filter(e => this.state.usercustomers.length === 0 ? e : this.state.usercustomers.includes(e.customer))
          .map(e => Object.assign(e, {
            invstatus: e.invstatus === "Processing" ? e.ledgerentry === "Pending" ? "JRE Pending" : e.payment === "Pending" ? "Payment Pending" : e.deliverystatus === "Pending" ? "Delivery Pending" : e.invstatus : e.invstatus,
            month: moment.utc(e.createdAt).format("YYYY-MM-DD") >= moment.utc(datadao.startdate).format("YYYY-MM-DD") &&
              moment.utc(e.createdAt).format("YYYY-MM-DD") <= moment.utc(datadao.enddate).format("YYYY-MM-DD") ?
              moment.utc(e.createdAt).format("MMMM") : ""
          })),
      }, () => {
        this.updateFilteredData();
      })
    })
      .catch((e) => {
        if (e.response?.data?.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      })
    // Call all Tax Invoice APIs
    SalesServices.GetSalesInvoiceDetails(datadao)
      .then(response => {
        this.setState({
          Invoice: response.data.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1)
            .filter(e => this.state.usercustomers.length === 0 ? e : this.state.usercustomers.includes(e.customer))
            .map(e => Object.assign(e, {
              month: moment.utc(e.createdAt).format("YYYY-MM-DD") >= moment.utc(datadao.startdate).format("YYYY-MM-DD") &&
                moment.utc(e.createdAt).format("YYYY-MM-DD") <= moment.utc(datadao.enddate).format("YYYY-MM-DD") ?
                moment.utc(e.createdAt).format("MMMM") : ""
            })),
        }, () => {
          this.updateFilteredData();
        })
      })
      .catch((e) => {
        if (e.response?.data?.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      })

    SalesServices.GetPendingInvoiceDetails(datadao)
      .then(response => {
        this.setState({
          pendingInvoice: response.data.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1)
            .filter(e => this.state.usercustomers.length === 0 ? e : this.state.usercustomers.includes(e.customer)),
        }, () => {
          this.updateFilteredData();
        })
      })
      .catch((e) => {
        if (e.response?.data?.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      })

    SalesServices.GetCompletedInvoice(datadao)
      .then(response => {
        this.setState({
          CompletedInvoice: response.data.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1)
            .filter(e => this.state.usercustomers.length === 0 ? e : this.state.usercustomers.includes(e.customer))
            .map(e => Object.assign(e, {
              month: moment.utc(e.createdAt).format("YYYY-MM-DD") >= moment.utc(datadao.startdate).format("YYYY-MM-DD") &&
                moment.utc(e.createdAt).format("YYYY-MM-DD") <= moment.utc(datadao.enddate).format("YYYY-MM-DD") ?
                moment.utc(e.createdAt).format("MMMM") : ""
            })),
        }, () => {
          this.updateFilteredData();
        })
      })

    SalesServices.GetCancelleddInvoices(datadao)
      .then(response => {
        this.setState({
          CancelledInvoice: response.data.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1)
            .filter(e => this.state.usercustomers.length === 0 ? e : this.state.usercustomers.includes(e.customer)),
        }, () => {
          this.updateFilteredData();
        })
      })
  }

  fetchProformaInvoiceData(datadao) {
    // Call all Proforma Invoice APIs
    SalesServices.getProformaInvoiceofTenant(datadao)
      .then(res => {
        this.setState({
          proformaInvoice: res.data.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1)
            .filter(e => this.state.usercustomers.length === 0 ? e : this.state.usercustomers.includes(e.customer))
        }, () => {
          this.updateFilteredData();
        })
      })

    SalesServices.getCompletedProformaInvoiceofTenant(datadao)
      .then(res => {
        this.setState({
          proformaInvoiceCompleted: res.data.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1)
            .filter(e => this.state.usercustomers.length === 0 ? e : this.state.usercustomers.includes(e.customer))
        }, () => {
          this.updateFilteredData();
        })
      })
  }

  fetchAssetInvoiceData(datadao) {
    AssetsService.GetAssetInvoicebyTenantid(currentTenant)
      .then(res => {
        // Filter by date if date filter is applied
        let filteredData = res.data;
        if (this.state.dateFilterApplied) {
          filteredData = res.data.filter(item =>
            moment(item.createdAt).isBetween(this.state.fromdate, this.state.todate, null, '[]')
          );
        }

        this.setState({
          rentInvoice: filteredData.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1)
            .filter(e => (this.state.usercustomers.length === 0 ? e : this.state.usercustomers.includes(e.customer)) && e.rentasset !== null),
          soldInvoice: filteredData.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1)
            .filter(e => (this.state.usercustomers.length === 0 ? e : this.state.usercustomers.includes(e.customer)) && e.soldassets !== null),
        }, () => {
          this.updateFilteredData();
        })
      })
  }

  updateFilteredData(resetPage = false) {
    const { searchTerm, type, active, pending, comp, cancel, rent, sales } = this.state;

    let data = [];
    switch (type) {
      case "Tax Invoice":
        if (pending) data = this.state.pendingInvoice;
        else if (active) data = this.state.Invoice;
        else if (comp) data = this.state.CompletedInvoice;
        else if (cancel) data = this.state.CancelledInvoice;
        else data = this.state.AllInvoice;
        break;
      case "Proforma Invoice":
        if (active) data = this.state.proformaInvoice;
        else if (comp) data = this.state.proformaInvoiceCompleted;
        break;
      case "Asset Invoice":
        if (rent) data = this.state.rentInvoice;
        else if (sales) data = this.state.soldInvoice;
        break;
      default:
        data = this.state.Invoice;
    }

    let filtered = data;
    if (searchTerm && searchTerm.trim()) {
      const cleanSearch = searchTerm.replace(/[^\w₹$€]/g, '').toLowerCase();

      filtered = data.filter((item) => {
        const checkFields = [
          item.customer,
          item.custominvid,
          item.customsoid,
          item.totalinvoice?.toString(),
          item.cctotalinvoice?.toString(),
          item.paid?.toString(),
          item.due?.toString(),
          item.currency,
          item.taxamount?.toString(),
          item.cctaxamount?.toString(),
        ];

        return checkFields.some((field) => {
          if (field === undefined || field === null) return false;

          const raw = String(field);
          const cleanField = raw.replace(/[^\w₹$€]/g, '').toLowerCase();

          return (
            cleanField.includes(cleanSearch) ||
            raw.toLowerCase().includes(searchTerm.toLowerCase())
          );
        });
      });
    }

    const itemsPerPage = this.state.itemsPerPage || 20;
    const totalPages = Math.max(1, Math.ceil(filtered.length / itemsPerPage));
    let targetPage = resetPage ? 1 : (this.state.currentPage || 1);
    if (filtered.length > 0 && targetPage > totalPages) {
      targetPage = totalPages;
    }

    let updatedSelectedInvoice = this.state.selectedInvoice;
    if (this.state.currentView === 'detail') {
      const targetId = this.state.selectedInvoice?.invid || this.state.savedSelectedInvoiceId;
      if (targetId && filtered.length > 0) {
        const found = filtered.find((inv) => inv.invid === targetId);
        if (found) {
          updatedSelectedInvoice = found;
        }
      }
    }

    this.setState({
      filteredData: filtered,
      filteredSidebarData: filtered,
      currentPage: targetPage,
      selectedInvoice: updatedSelectedInvoice,
      loading: false
    }, () => {
      this.saveTableState();
    });
  }

  // Get current status label
  getCurrentStatusLabel() {
    const { type, all, active, pending, comp, cancel, rent, sales } = this.state;

    if (type === "Tax Invoice") {
      if (all) return "All"
      if (active) return "Active";
      if (pending) return "Approval Pending";
      if (comp) return "Completed";
      if (cancel) return "Cancelled";
    } else if (type === "Proforma Invoice") {
      if (active) return "Active";
      if (comp) return "Completed";
    } else if (type === "Asset Invoice") {
      if (rent) return "Rental";
      if (sales) return "Excess Sales";
    }
    return "All";
  }

  // Get current data for export
  getExportData() {
    const sortedData = this.getSortedData(this.state.filteredData);
    return sortedData.map(item => {
      // Use prioritized amounts
      const totalinvoiceVal = this.getPrimaryAmount(item, 'totalinvoice', 'cctotalinvoice');
      const taxamountVal = this.getPrimaryAmount(item, 'taxamount', 'cctaxamount');
      return {
        ...item,
        createdAt: moment.utc(item.createdAt).format("DD-MM-YYYY HH:mm"),
        totalinvoice: this.formatCurrencyAsString(totalinvoiceVal),
        paid: item.paid ? this.formatCurrencyAsString(item.paid) : '0.00',
        due: item.due ? this.formatCurrencyAsString(item.due) : '0.00',
        taxamount: this.formatCurrencyAsString(taxamountVal)
      };
    });
  }

  // Toggle export dropdown
  toggleExportDropdown() {
    this.setState(prevState => ({
      exportDropdownOpen: !prevState.exportDropdownOpen
    }));
  }

  // Close export dropdown
  closeExportDropdown() {
    this.setState({ exportDropdownOpen: false });
  }

  exportPDF() {
    this.closeExportDropdown();

    const data = this.getExportData();
    console.log("LINE695: ", data)
    const curdate = moment.utc().format('DD-MM-YYYY HH:mm:ss');
    const statusLabel = this.getCurrentStatusLabel();
    const typeLabel = this.state.type;

    // Calculate min and max dates from invoices data
    let dateFilterInfo;
    if (data && data.length > 0) {
      // Extract all dates and convert to moment objects with correct format
      const dates = data
        .map(item => {
          // Parse date with correct format - data shows "DD-MM-YYYY HH:mm"
          return moment(item.createdAt, 'DD-MM-YYYY HH:mm');
        })
        .filter(date => date.isValid())
        .sort((a, b) => a - b);

      if (dates.length > 0) {
        const fromDate = dates[0];
        const toDate = dates[dates.length - 1];

        dateFilterInfo = `${fromDate.format("DD MMM YYYY")} - ${toDate.format("DD MMM YYYY")}`;
      } else {
        dateFilterInfo = 'Date Not Available';
      }
    } else {
      dateFilterInfo = 'No Invoices';
    }

    // Define columns based on type and status with optimized widths for landscape A4
    const columns = [
      { header: "Customer", dataKey: 'customer' },
      { header: "Invoice ID", dataKey: this.state.type === "Tax Invoice" ? 'custominvid' : 'invid' },
      { header: "Sale Order ID", dataKey: 'customsoid' },
      { header: "Created Date", dataKey: 'createdAt' },
      { header: "Total Amount", dataKey: 'totalinvoice' },
    ];
    // Add extra columns for Tax Invoice Active status
    if (this.state.type === "Tax Invoice" && (this.state.active || this.state.all)) {
      columns.push(
        { header: "Amount Received", dataKey: 'paid' },
        { header: "Amount Due", dataKey: 'due' }
      );

      if (this.state.all) {
        columns.push(
          { header: "Status", dataKey: 'invstatus' }
        );
      }
    }

    // Add tax amount and status columns
    columns.push(
      { header: "Tax Amount", dataKey: 'taxamount' },
      { header: "Status", dataKey: 'approvestatus' }
    );

    // Create PDF in landscape mode
    const doc = new jsPDF('l', 'mm', 'a4');

    const pageWidth = doc.internal.pageSize.getWidth(); // 297mm for landscape A4
    const pageHeight = doc.internal.pageSize.getHeight();

    // Set page margins for border effect
    const leftMargin = 15;
    const rightMargin = 10;
    const topMargin = 5;
    const bottomMargin = 10;

    // Calculate content area
    const contentWidth = pageWidth - leftMargin - rightMargin;

    let yPosition = topMargin + 10;

    // ===== HEADER SECTION =====
    const companyNameMaxWidth = contentWidth * 0.9;
    const logoAreaWidth = 40;

    // Set styles for company name
    doc.setFontSize(8);
    doc.setFont(undefined, 'bold');
    doc.text(clientname, leftMargin + 5, yPosition, {
      maxWidth: companyNameMaxWidth,
      align: 'left',
      overflow: 'linebreak'
    });

    // Calculate company name height to position other elements correctly
    const companyNameLines = doc.splitTextToSize(clientname, companyNameMaxWidth);
    const companyNameHeight = companyNameLines.length * 5;

    yPosition += companyNameHeight;

    // ===== DOCUMENT TITLE (between company name and date range) =====
    doc.setFontSize(7.5);
    doc.setFont(undefined, 'normal');
    doc.text(
      `${typeLabel} - ${statusLabel}`,
      leftMargin + 5,
      yPosition
    );

    yPosition += 4;

    // ===== FILTER INFO SECTION =====

    doc.setFontSize(7);
    doc.setFont(undefined, 'normal');
    doc.text(`Date Range :`, leftMargin + 5, yPosition);
    doc.setFont(undefined, 'normal');
    doc.text(`${dateFilterInfo}`, leftMargin + 25, yPosition);

    yPosition += 4;

    doc.setFontSize(7);
    doc.setFont(undefined, 'normal');
    doc.text(`Export Date :`, leftMargin + 5, yPosition);
    doc.setFont(undefined, 'normal');
    doc.text(`${curdate}`, leftMargin + 25, yPosition);


    yPosition += 5;

    // ===== TABLE SECTION =====
    const tableColumns = columns.map(col => ({
      header: col.header,
      dataKey: col.dataKey,
    }));

    const tableData = data.map(item => {
      const row = {};
      columns.forEach(col => {
        row[col.dataKey] = item[col.dataKey] || '';
      });
      return row;
    });

    // Calculate column widths with fixed proportions
    const availableWidth = contentWidth;

    const baseWidthMap = {
      customer: 20,
      custominvid: 12,
      invid: 12,
      customsoid: 12,
      createdAt: 10,
      totalinvoice: 10,
      paid: 10,
      due: 10,
      taxamount: 8,
      approvestatus: 8,
    };

    const activeKeys = columns.map(c => c.dataKey);

    const totalWeight = activeKeys.reduce(
      (sum, key) => sum + (baseWidthMap[key] || 10),
      0
    );

    const normalizedWidthMap = {};
    activeKeys.forEach(key => {
      normalizedWidthMap[key] =
        (baseWidthMap[key] || 10) / totalWeight * availableWidth;
    });

    // Calculate column styles
    const columnStyles = columns.reduce((acc, col, index) => {
      acc[index] = {
        cellWidth: normalizedWidthMap[col.dataKey],
        halign: ['totalinvoice', 'paid', 'due', 'taxamount'].includes(col.dataKey)
          ? 'right'
          : 'left',
      };
      return acc;
    }, {});

    // Generate the table first
    autoTable(doc, {
      startY: yPosition,
      margin: { left: leftMargin, right: rightMargin, top: 10, bottom: bottomMargin },
      tableWidth: availableWidth,
      head: [tableColumns.map(col => col.header)],
      body: tableData.map(item => tableColumns.map(col => String(item[col.dataKey] || ''))),
      theme: 'grid',
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontSize: 7,
        fontStyle: 'bold',
        halign: 'center',
        valign: 'middle',
        cellPadding: 3,
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
      },
      bodyStyles: {
        fontSize: 6,
        textColor: [0, 0, 0],
        cellPadding: 2,
        valign: 'middle',
        overflow: 'linebreak',
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
      },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columnStyles: columnStyles,
      styles: {
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
        font: 'helvetica',
        overflow: 'linebreak',
      },
      didDrawPage: (data) => {
        // Footer with centered page numbers only
        const footerY = pageHeight - bottomMargin + 5;

        doc.setFontSize(7);
        doc.setTextColor(0, 0, 0);

        // Center the page number
        const pageText = `Page ${data.pageNumber} of ${data.pageCount}`;
        const textWidth = doc.getTextWidth(pageText);

        doc.text(
          pageText,
          leftMargin + (contentWidth - textWidth) / 2,
          footerY
        );
      },
      willDrawCell: (data) => {
        // Ensure text doesn't overflow in customer column
        if (data.column.dataKey === 'customer' && data.cell.width) {
          const text = String(data.cell.raw || '');
          const maxWidth = data.cell.width - 4;
          const lines = doc.splitTextToSize(text, maxWidth);
          if (lines.length > 1) {
            data.cell.text = lines;
            data.row.height = Math.max(data.row.height || 0, lines.length * 4);
          }
        }
      },
    });

    // Generate and save PDF
    const filename = `${clientname}_${typeLabel.replace(/\s+/g, '_')}_${statusLabel.replace(/\s+/g, '_')}_${moment().format('DDMMYYYY_HHmm')}.pdf`;
    doc.save(filename);

    this.refreshSalesorder();
  }

  // Export CSV
  exportCSV() {
    this.closeExportDropdown();

    const data = this.getExportData();
    console.log("LINE695: ", data)
    const statusLabel = this.getCurrentStatusLabel();
    const typeLabel = this.state.type;
    const curdate = moment.utc().format('DD-MM-YYYY HH:mm:ss');

    // Calculate min and max dates from invoices data - MATCHING PDF LOGIC
    let dateFilterInfo;
    if (data && data.length > 0) {
      // Extract all dates and convert to moment objects with correct format
      const dates = data
        .map(item => {
          // Parse date with correct format - data shows "DD-MM-YYYY HH:mm"
          return moment(item.createdAt, 'DD-MM-YYYY HH:mm');
        })
        .filter(date => date.isValid())
        .sort((a, b) => a - b);

      if (dates.length > 0) {
        const fromDate = dates[0];
        const toDate = dates[dates.length - 1];

        dateFilterInfo = `${fromDate.format("DD MMM YYYY")} - ${toDate.format("DD MMM YYYY")}`;
      } else {
        dateFilterInfo = 'Date Not Available';
      }
    } else {
      dateFilterInfo = 'No Invoices';
    }

    const csvData = [];

    // ===== HEADER SECTION =====
    csvData.push([clientname]);
    csvData.push([`${typeLabel} - ${statusLabel}`]);
    csvData.push([`Date Range: ${dateFilterInfo}`]);
    csvData.push([`Export Date: ${curdate}`]);
    csvData.push([]); // Empty row for spacing

    // ===== COLUMN HEADERS - MATCHING PDF COLUMNS =====
    const headers = [
      "Customer",
      "Invoice ID",
      "Sale Order ID",
      "Created Date",
      "Total Amount",
    ];

    if (this.state.type === "Tax Invoice" && (this.state.active || this.state.all)) {
      headers.push("Amount Received", "Amount Due");
      if (this.state.all) {
        headers.push("Status");
      }
    }

    headers.push("Tax Amount", "Status");

    csvData.push(headers);

    // ===== DATA ROWS =====
    data.forEach(item => {
      const row = [
        item.customer || '',
        (this.state.type === "Tax Invoice" ? item.custominvid : item.invid) || '',
        item.customsoid || '',
        item.createdAt || '',
        item.totalinvoice || '0.00',
      ];

      if (this.state.type === "Tax Invoice" && (this.state.active || this.state.all)) {
        row.push(
          item.paid || '0.00',
          item.due || '0.00'
        );
        if (this.state.all) {
          row.push(item.invstatus)
        }
      }

      row.push(
        item.taxamount || '0.00',
        item.approvestatus || ''
      );

      csvData.push(row);
    });

    // ===== WORKSHEET CONFIGURATION =====
    const ws = utils.aoa_to_sheet(csvData);

    // Configure column widths for readability
    const wscols = [
      { wch: 30 }, // Customer
      { wch: 18 }, // Invoice ID
      { wch: 16 }, // Sale Order ID
      { wch: 15 }, // Created Date
      { wch: 14 }, // Total Amount
    ];

    // Add conditional column widths - matching PDF
    if (this.state.type === "Tax Invoice" && (this.state.active || this.state.all)) {
      wscols.push(
        { wch: 15 }, // Amount Received
        { wch: 13 }  // Amount Due
      );
      if (this.state.all) {
        wscols.push({ wch: 13 })
      }
    }

    wscols.push(
      { wch: 12 }, // Tax Amount
      { wch: 12 }  // Status
    );

    ws['!cols'] = wscols;

    ws['!freeze'] = { xSplit: 0, ySplit: 5 };

    // ===== WORKBOOK CREATION =====
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Invoices');

    // Generate and download file
    const filename = `${clientname}_${typeLabel.replace(/\s+/g, '_')}_${statusLabel.replace(/\s+/g, '_')}_${moment().format('DDMMYYYY_HHmm')}.xlsx`;
    writeFile(wb, filename);

    this.refreshSalesorder();
  }

  // Legacy PDF function (kept for backward compatibility)
  pdf() {
    this.exportPDF();
  }


  handleChangeStatusTab = (value) => {
    this.setState({ activeTab: value }, () => {
      switch (value) {
        case 'all':
          this.handleAllChange();
          break;
        case 'active':
          this.handleActiveChange();
          break;
        case 'pending':
          this.handlePendingChange();
          break;
        case 'comp':
          this.handlecompChange();
          break;
        case 'cancel':
          this.handleCancelChange();
          break;
      }
    });
  }


  handlePendingChange() {
    this.setState({
      pending: true,
      all: false,
      active: false,
      comp: false,
      cancel: false,
      currentView: 'list',
      selectedInvoice: null,
      sortConfig: { key: 'createdAt', direction: 'desc' }
    }, () => {
      this.updateFilteredData(true);
    });
  }

  handleAllChange() {
    this.setState({
      all: true,
      pending: false,
      active: false,
      comp: false,
      cancel: false,
      currentView: 'list',
      selectedInvoice: null,
      sortConfig: { key: 'createdAt', direction: 'desc' }
    }, () => {
      this.updateFilteredData(true);
    });
  }

  handleActiveChange() {
    this.setState({
      all: false,
      pending: false,
      active: true,
      comp: false,
      cancel: false,
      currentView: 'list',
      selectedInvoice: null,
      sortConfig: { key: 'createdAt', direction: 'desc' }
    }, () => {
      this.updateFilteredData(true);
    });
  }

  handlecompChange() {
    this.setState({
      all: false,
      pending: false,
      comp: true,
      active: false,
      cancel: false,
      currentView: 'list',
      selectedInvoice: null,
      sortConfig: { key: 'createdAt', direction: 'desc' }
    }, () => {
      this.updateFilteredData(true);
    });
  }

  handleCancelChange() {
    this.setState({
      all: false,
      pending: false,
      cancel: true,
      comp: false,
      active: false,
      currentView: 'list',
      selectedInvoice: null,
      sortConfig: { key: 'createdAt', direction: 'desc' }
    }, () => {
      this.updateFilteredData(true);
    });
  }

  handleSearch(term) {
    this.setState({ searchTerm: term }, () => {
      this.updateFilteredData(true);
    });
  }

  getCurrentData() {
    switch (this.state.type) {
      case "Tax Invoice":
        if (this.state.pending) return this.state.pendingInvoice;
        if (this.state.active) return this.state.Invoice;
        if (this.state.comp) return this.state.CompletedInvoice;
        if (this.state.cancel) return this.state.CancelledInvoice;
        return this.state.AllInvoice;
      case "Proforma Invoice":
        if (this.state.active) return this.state.proformaInvoice;
        if (this.state.comp) return this.state.proformaInvoiceCompleted;
        return this.state.proformaInvoice;
      case "Asset Invoice":
        if (this.state.rent) return this.state.rentInvoice;
        if (this.state.sales) return this.state.soldInvoice;
        return this.state.rentInvoice;
      default:
        return this.state.AllInvoice;
    }
  }

  // FIXED DATE HANDLERS
  handleFromDateChange = (date) => {
    if (!date) return;

    // Convert Dayjs to Moment properly
    const momentDate = moment(date.$d || date.toDate());

    this.setState({
      fromdate: momentDate,
      todate: momentDate.isAfter(this.state.todate) ? momentDate : this.state.todate,
    });
  };

  handleToDateChange = (date) => {
    if (!date) return;

    // Convert Dayjs to Moment properly
    const momentDate = moment(date.$d || date.toDate());
    this.setState({
      todate: momentDate
    });
  };

  handleApplyDateFilter = () => {
    this.setState({ dateFilterApplied: true, currentPage: 1 }, () => {
      this.refreshSalesorder(true);
      this.saveTableState();
    });
  };

  handlePreviousMonth = () => {
    const startOfPrevMonth = moment().subtract(1, 'months').startOf('month');
    const endOfPrevMonth = moment().subtract(1, 'months').endOf('month');

    this.setState({
      fromdate: startOfPrevMonth,
      todate: endOfPrevMonth,
      dateFilterApplied: true,
      currentPage: 1
    }, () => {
      this.refreshSalesorder(true);
      this.saveTableState();
    });
  };

  handleClearFilter = () => {
    this.setState({
      fromdate: moment().subtract(7, "days"),
      todate: moment(),
      dateFilterApplied: false,
      currentPage: 1
    }, () => {
      this.refreshSalesorder(false);
      this.saveTableState();
    });
  };

  getCurrentPageData() {
    const { filteredData, currentPage, itemsPerPage } = this.state;
    const sortedData = this.getSortedData(filteredData);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return sortedData.slice(indexOfFirstItem, indexOfLastItem);
  }

  handlePageChange(newPage) {
    this.setState({ currentPage: newPage }, () => {
      this.saveTableState();
    });
  }

  handleItemsPerPageChange(e) {
    this.setState({
      itemsPerPage: parseInt(e.target.value),
      currentPage: 1
    }, () => {
      this.updateFilteredData(true);
    });
  }

  handleInvoiceClick(invoice) {
    this.setState({
      selectedInvoice: invoice,
      savedSelectedInvoiceId: invoice.invid,
      lastViewedInvoiceId: invoice.invid,
      currentView: 'detail',
      hasScrolledToSelected: false
    }, () => {
      this.setState({
        filteredSidebarData: this.state.filteredData
      }, () => {
        this.saveTableState();
      });
    });
  }

  handleBackToList() {
    this.setState({
      currentView: 'list',
      selectedInvoice: null,
      savedSelectedInvoiceId: null,
      hasScrolledToSelected: false
    }, () => {
      this.updateFilteredData(false);
    });
  }

  renderTable() {
    const isMobile = this.state.isMobile;
    const currentPageData = this.getCurrentPageData();

    if (this.state.filteredData.length === 0) {
      return (
        <div className={`UI-no-items-message ${isMobile ? 'UI-no-items-message-mobile' : ''}`}>
          {this.state.searchTerm ? 'No invoices found matching your search' : 'No invoices available'}
        </div>
      );
    }

    return (
      <>
        <div className={`UI-table-container ${isMobile ? 'UI-table-container-mobile' : ''}`}>
          <table className={`UI-table ${isMobile ? 'UI-table-mobile' : ''}`}>
            <thead className="UI-table-header">
              <tr>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'customer' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('customer')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Customer
                    <this.SortIndicator columnKey="customer" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'custominvid' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('custominvid')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Invoice ID
                    <this.SortIndicator columnKey="custominvid" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'createdAt' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('createdAt')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Created At
                    <this.SortIndicator columnKey="createdAt" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'totalinvoice' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('totalinvoice')}
                  style={{ cursor: 'pointer', textAlign: 'right' }}
                >
                  <div className="UI-th-content" style={{ justifyContent: 'flex-end' }}>
                    Total Amount
                    <this.SortIndicator columnKey="totalinvoice" />
                  </div>
                </th>

                {this.state.type === "Tax Invoice" && (this.state.active || this.state.all) && (
                  <>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'paid' ? 'UI-th-sorted' : ''}`}
                      onClick={() => this.sortData('paid')}
                      style={{ cursor: 'pointer', textAlign: 'right' }}
                    >
                      <div className="UI-th-content" style={{ justifyContent: 'flex-end' }}>
                        Amount Received
                        <this.SortIndicator columnKey="paid" />
                      </div>
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'due' ? 'UI-th-sorted' : ''}`}
                      onClick={() => this.sortData('due')}
                      style={{ cursor: 'pointer', textAlign: 'right' }}
                    >
                      <div className="UI-th-content" style={{ justifyContent: 'flex-end' }}>
                        Due
                        <this.SortIndicator columnKey="due" />
                      </div>
                    </th>
                    {this.state.all &&
                      <th
                        className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'status' ? 'UI-th-sorted' : ''}`}
                        onClick={() => this.sortData('status')}
                        style={{ cursor: 'pointer', textAlign: 'right' }}
                      >
                        <div className="UI-th-content" style={{ justifyContent: 'flex-end' }}>
                          Status
                          <this.SortIndicator columnKey="due" />
                        </div>
                      </th>
                    }
                  </>
                )}

                <th className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`} style={{ textAlign: 'center' }}>Actions</th>
              </tr>
            </thead>

            <tbody>
              {currentPageData.map((invoice) => (
                <tr
                  key={invoice.invid}
                  data-row-invoice-id={invoice.invid}
                  className={`UI-table-row ${isMobile ? 'UI-table-row-mobile' : ''} ${invoice.invstatus === "Cancelled" ? "!tw-bg-red-50/50" : invoice.invstatus === "Completed" ? "!tw-bg-green-50/50" : ""} ${this.state.hoveredRow === invoice.invid ? 'UI-table-row-hovered' : ''} ${this.state.lastViewedInvoiceId === invoice.invid ? '!tw-bg-blue-50/70 !tw-border-l-4 !tw-border-l-blue-600' : ''}`}
                  onClick={() => {
                    this.setState({ lastViewedInvoiceId: invoice.invid }, () => {
                      this.saveTableState();
                    });
                    this.handleInvoiceClick(invoice);
                  }}
                  onMouseEnter={() => this.setState({ hoveredRow: invoice.invid })}
                  onMouseLeave={() => {
                    this.setState({ hoveredRow: null, isActionHovered: null });
                  }}
                >
                  {/* CUSTOMER NAME */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-item-name ${this.state.hoveredRow === invoice.invid ? 'UI-item-name-hover' : ''}`}
                  >
                    {(() => {
                      const name = invoice.customer || "";
                      const lastChar = name.slice(-1);
                      const rest = name.slice(0, -1);

                      return (
                        <>
                          <span>{this.highlightSearchText(rest, this.state.searchTerm)}</span>

                          <Tooltip
                            title="Overview"
                            placement="right"
                            arrow
                            slotProps={{
                              popper: {
                                sx: { pointerEvents: 'none' },
                              },
                            }}
                            open={
                              !this.state.isMobile &&
                              this.state.hoveredRow === invoice.invid &&
                              !this.state.isActionHovered
                            }
                          >
                            <span style={{ display: "inline-block" }}>
                              {this.highlightSearchText(lastChar, this.state.searchTerm)}
                            </span>
                          </Tooltip>
                        </>
                      );
                    })()}
                  </td>

                  {/* INVOICE ID */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    {this.highlightSearchText(
                      this.state.type === "Tax Invoice"
                        ? invoice.custominvid
                        : invoice.invid,
                      this.state.searchTerm
                    )}
                  </td>

                  {/* CREATED AT */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    {this.highlightSearchText(
                      moment.utc(invoice.createdAt).format("DD-MM-YYYY"),
                      this.state.searchTerm
                    )}
                  </td>

                  {/* TOTAL INVOICE - prioritized */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-amount ${this.state.hoveredRow === invoice.invid ? 'UI-price-hover' : ''}`}
                    style={{ textAlign: "right" }}
                  >
                    {(() => {
                      const primaryTotal = this.getPrimaryAmount(invoice, 'totalinvoice', 'cctotalinvoice');
                      const fallbackTotal = this.getFallbackAmount(invoice, 'totalinvoice', 'cctotalinvoice');
                      return this.formatCurrencyWithConversion(
                        primaryTotal,
                        fallbackTotal,
                        invoice.currency,
                        invoice.curconversionrate,
                        currency,
                        this.state.hoveredRow === invoice.invid ? "red" : '#4d4d4d',
                        this.state.searchTerm
                      );
                    })()}
                  </td>

                  {/* IF TAX INVOICE + ACTIVE */}
                  {this.state.type === "Tax Invoice" && (this.state.active || this.state.all) && (
                    <>
                      {/* PAID */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-amount`}
                        style={{ textAlign: "right", color: this.state.hoveredRow === invoice.invid ? "green" : "#4d4d4d" }}
                      >
                        {this.formatCurrencyWithConversion(
                          invoice.paid,
                          invoice.currency !== currency ? ((1 / invoice.curconversionrate) * invoice.paid) : null,
                          invoice.currency,
                          invoice.curconversionrate,
                          currency,
                          this.state.hoveredRow === invoice.invid ? "green" : "#4d4d4d",
                          this.state.searchTerm
                        )}
                      </td>

                      {/* DUE */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-amount`}
                        style={{ textAlign: "right", color: this.state.hoveredRow === invoice.invid ? "red" : "#4d4d4d" }}
                      >
                        {this.formatCurrencyWithConversion(
                          invoice.due,   // primary in global currency (INR)
                          invoice.currency !== currency ? invoice.due / invoice.curconversionrate : null,   // secondary in invoice currency (USD)
                          invoice.currency,
                          invoice.curconversionrate,
                          currency,
                          this.state.hoveredRow === invoice.invid ? "red" : "#4d4d4d",
                          this.state.searchTerm
                        )}
                      </td>
                      {this.state.all && <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-amount ${invoice.invstatus === "Cancelled" ? "!tw-bg-red-50/50 !tw-text-red-600" : invoice.invstatus === "Completed" ? "!tw-bg-green-50/50 !tw-text-green-600" : ""}`}
                        style={{ textAlign: "right", color: this.state.hoveredRow === invoice.invid && "red" }}
                      >
                        {this.highlightSearchText(
                          invoice.invstatus,
                          this.state.searchTerm
                        )}
                      </td>}
                    </>
                  )}

                  {/* ACTION BUTTONS */}
                  <td className={`UI-td ${isMobile ? 'UI-td-mobile' : 'tw-w-15'}`}>
                    <div className="UI-action-buttons  tw-flex !tw-justify-start">
                      <Link
                        to={{ pathname: "/viewsalesinvoice" }}
                        state={{
                          id: invoice.invid,
                          pagename:
                            this.state.type === "Tax Invoice"
                              ? "Tax Invoice Details"
                              : "Proforma Invoice Details",
                          type: this.state.type,
                          temp: this.state.pending,
                        }}
                        className={`UI-action-button ${isMobile ? 'UI-action-button-mobile' : ''} UI-edit-button`}
                        onClick={(e) => {
                          e.stopPropagation();
                          this.setState({ lastViewedInvoiceId: invoice.invid }, () => {
                            this.saveTableState();
                          });
                        }}
                        onMouseEnter={() =>
                          this.setState({ isActionHovered: `view-${invoice.invid}` })
                        }
                        onMouseLeave={() => this.setState({ isActionHovered: null })}
                      >
                        <Tooltip title="Full Details" arrow slotProps={{
                          popper: {
                            sx: { pointerEvents: 'none' },
                          },
                        }}>
                          <img
                            src={ViewIcon}
                            alt="View"
                            className={`UI-action-icon ${isMobile ? 'UI-action-icon-mobile' : ''} ${this.state.isActionHovered === `view-${invoice.invid}` ? 'UI-edit-icon-hover' : ''}`}
                          />
                        </Tooltip>
                      </Link>
                      {invoice.recurring === "TRUE" &&
                        <Tooltip title={`Recurring - ${invoice.recurringperiod}`} arrow slotProps={{
                          popper: {
                            sx: { pointerEvents: 'none' },
                          },
                        }}>
                          <img
                            src={RecurringIcon}
                            alt="View"
                            className={`UI-action-icon ${isMobile ? 'UI-action-icon-mobile' : ''} ${this.state.isActionHovered === `view-${invoice.invid}` ? 'UI-edit-icon-hover' : ''}`}
                          />
                        </Tooltip>}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {this.renderPagination()}
      </>
    );

  }

  renderTypeTabs() {
    const types = ["Tax Invoice", "Proforma Invoice", "Asset Invoice"];
    const options = [
      { value: "Tax Invoice", label: "Tax Invoice" },
      { value: "Proforma Invoice", label: "Proforma Invoice" },
      { value: "Asset Invoice", label: "Asset Invoice" },
    ]
    return (<>
      {/* <div
        className="UI-tabs-row"
        style={{
          marginBottom: "16px",
          marginTop: "10px",
          marginLeft: "10px",
        }}
      >
        {types.map((tabType) => (
          <TabButton
            key={tabType}
            active={this.state.type === tabType}
            onClick={() =>
              this.setState(
                {
                  type: tabType,
                  active: true,
                  pending: false,
                  comp: false,
                  cancel: false,
                  rent: true,
                  sales: false,
                  currentView: 'list',
                  selectedInvoice: null,
                  sortConfig: { key: 'createdAt', direction: 'desc' }
                },
                this.updateFilteredData
              )
            }
          >
            {tabType}
          </TabButton>
        ))}
      </div> */}
      <div className='tw-m-2'>
        <TabSwitch
          value={this.state.type}
          onChange={(value) => {
            this.setState(
              {
                type: value,
                active: true,
                pending: false,
                comp: false,
                cancel: false,
                rent: true,
                sales: false,
                currentView: 'list',
                selectedInvoice: null,
                sortConfig: { key: 'createdAt', direction: 'desc' }
              },
              this.updateFilteredData
            )
          }}
          activeTabClass={(theme === "modern" ? "tw-bg-gradient-to-r tw-from-blue-600 tw-to-indigo-600 tw-text-white tw-py-1" : "!tw-bg-[#4d4d4d] tw-text-white tw-py-1")}
          options={options}
        />
      </div>

    </>);
  }

  renderStatusTabs() {
    const isMobile = this.state.isMobile;
    const matchCounts = this.getTabMatchCounts();
    let options = [];
    if (this.state.type === "Asset Invoice") {
      // const tabs = [
      //   {
      //     key: 'rent', label: 'Rental', handler: () => this.setState({
      //       rent: true,
      //       sales: false,
      //       currentView: 'list',
      //       selectedInvoice: null,
      //       sortConfig: { key: 'createdAt', direction: 'desc' }
      //     }, () => {
      //       this.updateFilteredData();
      //     }), active: this.state.rent, count: matchCounts.rent
      //   },
      //   {
      //     key: 'sales', label: 'Excess Sales', handler: () => this.setState({
      //       rent: false,
      //       sales: true,
      //       currentView: 'list',
      //       selectedInvoice: null,
      //       sortConfig: { key: 'createdAt', direction: 'desc' }
      //     }, () => {
      //       this.updateFilteredData();
      //     }), active: this.state.sales, count: matchCounts.sales
      //   }
      // ];
      options = [
        { value: "rent", label: "Rental", count: matchCounts.rent },
        { value: "sales", label: "Excess Sales", count: matchCounts.sales }
      ];

      return (
        <div className="UI-quotation-tabs-container !tw-bg-white !tw-border-none">
          {/* {tabs.map((tab) => (
            <div
              key={tab.key}
              className={`UI-quotation-tab ${tab.active ? 'UI-quotation-active-tab' : ''
                } ${this.state.hovered === `${tab.key}-tab`
                  ? 'UI-quotation-tab-hovered'
                  : ''
                }`}
              onClick={tab.handler}
              onMouseEnter={() => this.setState({ hovered: `${tab.key}-tab` })}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              {tab.label}
              {tab.count > 0 && (
                <span className="UI-match-count">{tab.count}</span>
              )}
            </div>
          ))} */}


          <TabSwitch
            value={this.state.sales ? "sales" : "rent"}
            onChange={(value) => {
              this.setState({ rent: value === "rent", sales: value !== "rent", currentView: 'list', selectedInvoice: null, sortConfig: { key: 'createdAt', direction: 'desc' } }, () => { this.updateFilteredData() })
            }}
            options={options}
          />

          {/* Date Filters for all Asset Invoice tabs */}
          <div className="UI-date-filter-container !tw-bg-white !tw-border-none">
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              {this.state.dateFilterApplied && (
                <button
                  className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-outline UI-btn-clear-filter ${this.state.hovered === "clear" ? 'UI-btn-outline-hover' : ''}`}
                  onClick={this.handleClearFilter}
                  onMouseEnter={() => this.setState({ hovered: 'clear' })}
                  onMouseLeave={() => this.setState({ hovered: null })}
                >
                  <i className="fa fa-times" style={{ fontSize: '0.7rem' }} />
                  Clear
                </button>
              )}
              {/* <button
                className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-outline ${this.state.hovered === "prevMonth" ? 'UI-btn-outline-hover' : ''} !tw-px-2`}
                onClick={this.handlePreviousMonth}
                onMouseEnter={() => this.setState({ hovered: 'prevMonth' })}
                onMouseLeave={() => this.setState({ hovered: null })}
              >
                <i className="fa fa-calendar" style={{ fontSize: '0.7rem' }} />
                Prev Month
              </button> */}

              <Button variant='primary-outline-hover' onClick={this.handlePreviousMonth}><Calendar size={16} /> Prev Month</Button>
            </div>

            {/* Display selected date range in the middle */}
            {this.state.dateFilterApplied && (
              <div className={`UI-selected-date-range ${isMobile ? 'UI-selected-date-range-mobile' : ''}`}>
                <i className="fa fa-calendar-check" style={{ fontSize: '0.7rem', marginRight: '4px', color: '#4f46e5' }} />
                {this.state.fromdate.format("DD MMM YYYY")} - {this.state.todate.format("DD MMM YYYY")}
              </div>
            )}

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <DatePicker
                  label="From Date"
                  value={this.state.fromdate.toDate()} // Convert Moment to Date
                  onChange={this.handleFromDateChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      style={{ width: '140px' }}
                    />
                  )}
                />
                <span style={{ color: '#64748b', fontSize: '0.8rem' }}>to</span>
                <DatePicker
                  label="To Date"
                  value={this.state.todate.toDate()} // Convert Moment to Date
                  onChange={this.handleToDateChange}
                  minDate={this.state.fromdate.toDate()}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      style={{ width: '140px' }}
                    />
                  )}
                />
              </div>
            </LocalizationProvider>
            {/* <button
              className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-outline ${this.state.hovered === "apply" ? 'UI-btn-outline-hover' : ''}`}
              onClick={this.handleApplyDateFilter}
              onMouseEnter={() => this.setState({ hovered: 'apply' })}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              <i className="fa fa-filter" style={{ fontSize: '0.7rem' }} />
              Apply
            </button> */}

            <Button variant='primary-outline-hover' onClick={this.handleApplyDateFilter}><Calendar size={16} /> Apply</Button>
          </div>
        </div>
      );

    }

    const tabs = this.state.type === "Tax Invoice"
      ? [
        { key: 'all', label: 'All', handler: this.handleAllChange, active: this.state.all, count: matchCounts.all },
        { key: 'active', label: 'Active', handler: this.handleActiveChange, active: this.state.active, count: matchCounts.active },
        { key: 'pending', label: 'Approval Pending', handler: this.handlePendingChange, active: this.state.pending, count: matchCounts.pending },
        { key: 'comp', label: 'Completed', handler: this.handlecompChange, active: this.state.comp, count: matchCounts.comp },
        { key: 'cancel', label: 'Cancelled', handler: this.handleCancelChange, active: this.state.cancel, count: matchCounts.cancel }
      ]
      : [
        { key: 'active', label: 'Active', handler: this.handleActiveChange, active: this.state.active, count: matchCounts.proformaActive },
        { key: 'comp', label: 'Completed', handler: this.handlecompChange, active: this.state.comp, count: matchCounts.proformaComp }
      ];
    options = this.state.type === "Tax Invoice" ?
      [
        { value: "all", label: "All", count: matchCounts.all },
        { value: "active", label: "Active", count: matchCounts.active },
        { value: "pending", label: "Pending", count: matchCounts.pending },
        { value: "comp", label: "Completed", count: matchCounts.comp },
        { value: "cancel", label: "Cancelled", count: matchCounts.cancel }
      ] :
      [
        { value: "active", label: "Active", count: matchCounts.proformaActive },
        { value: "comp", label: "Completed", count: matchCounts.proformaComp }
      ]

    return (
      <div className="UI-quotation-tabs-container !tw-bg-white !tw-border-none">
        {/* {tabs.map((tab) => (
          <div
            key={tab.key}
            className={`UI-quotation-tab ${tab.active ? 'UI-quotation-active-tab' : ''
              } ${this.state.hovered === `${tab.key}-tab`
                ? 'UI-quotation-tab-hovered'
                : ''
              }`}
            onClick={tab.handler}
            onMouseEnter={() => this.setState({ hovered: `${tab.key}-tab` })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {tab.label}
            {tab.count > 0 && (
              <span className="UI-match-count">{tab.count}</span>
            )}
          </div>
        ))} */}

        <TabSwitch
          value={this.state.activeTab}
          onChange={this.handleChangeStatusTab}
          options={options}
        />

        {/* Date Filters for all tabs */}
        <div className="UI-date-filter-container !tw-bg-white !tw-border-none">
          {/* Display selected date range in the middle with close icon */}
          {this.state.dateFilterApplied && (
            <div className={`UI-selected-date-range ${isMobile ? 'UI-selected-date-range-mobile' : ''}`}>
              {this.state.fromdate.format("DD MMM YYYY")} - {this.state.todate.format("DD MMM YYYY")}
              <button
                className="UI-date-range-close"
                onClick={this.handleClearFilter}
                onMouseEnter={() => this.setState({ hovered: 'dateRangeClose' })}
                onMouseLeave={() => this.setState({ hovered: null })}
                aria-label="Clear date filter"
              >
                <i className="fa fa-times" style={{ fontSize: '0.7rem' }} />
              </button>
            </div>
          )}

          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            {/* <button
              className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-outline ${this.state.hovered === "prevMonth" ? 'UI-btn-outline-hover' : ''}`}
              onClick={this.handlePreviousMonth}
              onMouseEnter={() => this.setState({ hovered: 'prevMonth' })}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              <i className="fa fa-calendar" style={{ fontSize: '0.7rem' }} />
              Prev Month
            </button> */}

            <Button variant='primary-outline-hover' size='sma' onClick={this.handlePreviousMonth}><Calendar size={16} /> Prev Month</Button>
          </div>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <DatePicker
                label="From Date"
                value={this.state.fromdate.toDate()} // Convert Moment to Date
                onChange={this.handleFromDateChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    style={{ width: '140px' }}
                  />
                )}
              />
              <span style={{ color: '#64748b', fontSize: '0.8rem' }}>to</span>
              <DatePicker
                label="To Date"
                value={this.state.todate.toDate()} // Convert Moment to Date
                onChange={this.handleToDateChange}
                minDate={this.state.fromdate.toDate()}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    style={{ width: '140px' }}
                  />
                )}
              />
            </div>
          </LocalizationProvider>
          {/* <button
            className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-outline ${this.state.hovered === "apply" ? 'UI-btn-outline-hover' : ''}`}
            onClick={this.handleApplyDateFilter}
            onMouseEnter={() => this.setState({ hovered: 'apply' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            <i className="fa fa-filter" style={{ fontSize: '0.7rem' }} />
            Apply
          </button> */}

          <Button variant='primary-outline-hover' onClick={this.handleApplyDateFilter}><Calendar size={16} /> Apply</Button>
        </div>
      </div>
    );

  }

  renderPagination() {
    const { filteredData, currentPage, itemsPerPage, isMobile } = this.state;

    if (filteredData.length <= itemsPerPage) return null;

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    return (
      <div className={`UI-pagination-container ${isMobile ? 'UI-pagination-container-mobile' : ''}`}>
        <div className={`UI-pagination-info ${isMobile ? 'UI-pagination-info-mobile' : ''}`}>
          Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, filteredData.length)} of {filteredData.length} invoices
        </div>
        <div className={`UI-pagination-controls ${isMobile ? 'UI-pagination-controls-mobile' : ''}`}>
          <TextField
            select
            value={itemsPerPage}
            onChange={this.handleItemsPerPageChange}
            variant="outlined"
            size="small"
            className={`UI-page-size-select ${isMobile ? 'UI-page-size-select-mobile' : ''} ${this.state.hovered === 'pagesize' ? 'UI-page-size-select-hover' : ''}`}
            onMouseEnter={() => this.setState({ hovered: 'pagesize' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            <MenuItem value={5}>5 per page</MenuItem>
            <MenuItem value={10}>10 per page</MenuItem>
            <MenuItem value={20}>20 per page</MenuItem>
            <MenuItem value={50}>50 per page</MenuItem>
          </TextField>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === 1 ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'first' && !(currentPage === 1) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(1)}
            disabled={currentPage === 1}
            onMouseEnter={() => !(currentPage === 1) && this.setState({ hovered: 'first' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'First' : 'First'}
          </button>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === 1 ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'prev' && !(currentPage === 1) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            onMouseEnter={() => !(currentPage === 1) && this.setState({ hovered: 'prev' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Prev' : 'Previous'}
          </button>

          <span className={`UI-pagination-info ${isMobile ? 'UI-pagination-info-mobile' : ''}`}>
            Page {currentPage} of {totalPages}
          </span>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === totalPages ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'next' && !(currentPage === totalPages) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            onMouseEnter={() => !(currentPage === totalPages) && this.setState({ hovered: 'next' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Next' : 'Next'}
          </button>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === totalPages ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'last' && !(currentPage === totalPages) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
            onMouseEnter={() => !(currentPage === totalPages) && this.setState({ hovered: 'last' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Last' : 'Last'}
          </button>
        </div>
      </div>
    );
  }

  renderListView() {
    return (
      <>
        {this.renderTypeTabs()}
        {this.renderStatusTabs()}
        {this.renderTable()}
      </>
    );
  }

  renderDetailView() {
    const { selectedInvoice, filteredSidebarData } = this.state;
    if (!selectedInvoice) return null;

    return (
      <div className="UI-detail-view">
        {/* Sidebar */}
        <div className="UI-sidebar">
          <div className="UI-sidebar-header">
            <button
              className={`UI-back-button ${this.state.hovered === 'back' ? 'UI-back-button-hover' : ''}`}
              onClick={this.handleBackToList}
              onMouseEnter={() => this.setState({ hovered: 'back' })}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              <i className="fa fa-arrow-left" /> Back
            </button>
          </div>
          <div className="UI-sidebar-list" ref={this.sidebarRef}>
            {filteredSidebarData.map((invoice) => (
              <div
                key={invoice.invid}
                data-invoice-id={invoice.invid}
                className={`UI-sidebar-item ${selectedInvoice.invid === invoice.invid ? 'UI-sidebar-item-active' : ''} ${this.state.hovered === invoice.invid ? 'UI-sidebar-item-hover' : ''}`}
                onClick={() => this.setState({ selectedInvoice: invoice })}
                onMouseEnter={() => this.setState({ hovered: invoice.invid })}
                onMouseLeave={() => this.setState({ hovered: null })}
              >
                <div className={`UI-sidebar-item-name ${this.state.hovered === invoice.invid ? 'UI-sidebar-item-name-hover' : ''}`}>
                  {this.highlightSearchText(invoice.customer, this.state.searchTerm)}
                </div>
                <div className={`UI-sidebar-item-code ${this.state.hovered === invoice.invid ? 'UI-sidebar-item-code-hover' : ''}`}>
                  {this.highlightSearchText(
                    this.state.type === "Tax Invoice" ? invoice.custominvid : invoice.invid,
                    this.state.searchTerm
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Detail Content */}
        <div className="UI-detail-content">
          <div className="UI-detail-header">
            <div className="UI-detail-title-wrapper">
              <h2 className="UI-detail-title">{this.highlightSearchText(selectedInvoice.customer, this.state.searchTerm)}</h2>
              <p className="UI-detail-subtitle">
                Invoice ID: {this.highlightSearchText(
                  this.state.type === "Tax Invoice" ? selectedInvoice.custominvid : selectedInvoice.invid,
                  this.state.searchTerm
                )}
              </p>
            </div>
            <div className="UI-detail-actions">
              <Link
                to={{ pathname: "/viewsalesinvoice" }}
                state={{
                  id: selectedInvoice.invid,
                  pagename: this.state.type === "Tax Invoice" ? 'Tax Invoice Details' : 'Proforma Invoice Details',
                  type: this.state.type,
                  temp: this.state.pending
                }}
                className={`UI-detail-action-button UI-detail-edit-button ${this.state.hovered === "view" ? 'UI-edit-button-hover' : ''}`}
                style={{ textDecoration: "none" }}
                onClick={() => {
                  this.setState({ lastViewedInvoiceId: selectedInvoice.invid }, () => {
                    this.saveTableState();
                  });
                }}
                onMouseEnter={() => this.setState({ hovered: "view" })}
                onMouseLeave={() => this.setState({ hovered: null })}
              >
                <Tooltip title="View Full Details" arrow slotProps={{
                  popper: {
                    sx: { pointerEvents: 'none' },
                  },
                }}>
                  <img
                    src={ViewIcon}
                    alt="View"
                    className={`UI-action-icon ${this.state.hovered === "view" ? 'UI-action-icon-hover' : ''}`}
                  />
                </Tooltip>
              </Link>
              {selectedInvoice.recurring === "TRUE" && <div
                className={`UI-detail-action-button UI-detail-edit-button`}
                style={{ textDecoration: "none" }}
              >
                <Tooltip title={`Recurring - ${selectedInvoice.recurringperiod}`} arrow slotProps={{
                  popper: {
                    sx: { pointerEvents: 'none' },
                  },
                }}>
                  <img
                    src={RecurringIcon}
                    alt="View"
                    className={`UI-action-icon`}
                  />
                </Tooltip>
              </div>}

            </div>
          </div>
          <div className="UI-detail-grid">
            {/* Basic Information */}
            <div className="UI-detail-section">
              <h3 className="UI-section-title">Basic Information</h3>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Customer</span>
                <span className="UI-detail-value">{this.highlightSearchText(selectedInvoice.customer, this.state.searchTerm)}</span>
              </div>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Invoice ID</span>
                <span className="UI-detail-value">
                  {this.highlightSearchText(
                    this.state.type === "Tax Invoice" ? selectedInvoice.custominvid : selectedInvoice.invid,
                    this.state.searchTerm
                  )}
                </span>
              </div>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Created Date</span>
                <span className="UI-detail-value">
                  {moment.utc(selectedInvoice.createdAt).format("DD-MM-YYYY HH:MM")}
                </span>
              </div>
              {selectedInvoice.duedate ?
                <div className="UI-detail-row">
                  <span className="UI-detail-label">Due Date</span>
                  <span className="UI-detail-value">
                    {moment.utc(selectedInvoice.duedate).format("DD-MM-YYYY") ? selectedInvoice.duedate
                      ? moment.utc(selectedInvoice.duedate).format("DD-MM-YYYY")
                      : moment.utc(selectedInvoice.createdAt).format("DD-MM-YYYY")
                      : ""}
                  </span>
                </div> :
                <div className="UI-detail-row">
                  <span className="UI-detail-label">Due Date</span>
                  <span className="UI-detail-value">
                    {selectedInvoice.duedate
                      ? moment.utc(selectedInvoice.duedate).format("DD-MM-YYYY")
                      : moment.utc(selectedInvoice.createdAt).format("DD-MM-YYYY")
                    }
                  </span>
                </div>
              }
              {selectedInvoice.customsoid && (
                <div className="UI-detail-row">
                  <span className="UI-detail-label">Sale Order ID</span>
                  <span className="UI-detail-value">{this.highlightSearchText(selectedInvoice.customsoid, this.state.searchTerm)}</span>
                </div>
              )}
            </div>
            {/* Financial Information */}
            <div className="UI-detail-section">
              <h3 className="UI-section-title">Financial Information</h3>

              <div className="UI-detail-row">
                <span className="UI-detail-label">Total Amount</span>
                <span className="UI-detail-value">
                  {(() => {
                    const primaryTotal = this.getPrimaryAmount(selectedInvoice, 'totalinvoice', 'cctotalinvoice');
                    const fallbackTotal = this.getFallbackAmount(selectedInvoice, 'totalinvoice', 'cctotalinvoice');
                    return this.formatCurrencyWithConversion(
                      primaryTotal,
                      fallbackTotal,
                      selectedInvoice.currency,
                      selectedInvoice.curconversionrate,
                      currency,
                      '#4d4d4d',
                      this.state.searchTerm
                    );
                  })()}
                </span>
              </div>

              {this.state.type === "Tax Invoice" && (this.state.active || this.state.all) && (
                <>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Amount Received</span>
                    <span className="UI-detail-value" style={{ color: 'green' }}>
                      {this.formatCurrencyWithConversion(
                        selectedInvoice.paid,
                        selectedInvoice.currency !== currency && selectedInvoice.cctotalinvoice ? (1 / selectedInvoice.curconversionrate) * selectedInvoice.paid : null,
                        selectedInvoice.currency,
                        selectedInvoice.curconversionrate,
                        currency,
                        'green',
                        this.state.searchTerm
                      )}
                    </span>
                  </div>

                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Due Amount</span>
                    <span className="UI-detail-value" style={{ color: 'red' }}>
                      {this.formatCurrencyWithConversion(
                        selectedInvoice.due,
                        selectedInvoice.currency !== currency && selectedInvoice.cctotalinvoice ? (1 / selectedInvoice.curconversionrate) * selectedInvoice.due : null,
                        selectedInvoice.currency,
                        selectedInvoice.curconversionrate,
                        currency,
                        'red',
                        this.state.searchTerm
                      )}
                    </span>
                  </div>
                  {this.state.all && <div className="UI-detail-row">
                    <span className="UI-detail-label">Status</span>
                    <span className={`UI-detail-value ${selectedInvoice.invstatus === "Cancelled" ? "!tw-text-red-600" : selectedInvoice.invstatus === "Completed" ? "!tw-text-green-600" : ""}`}>
                      {this.highlightSearchText(selectedInvoice.invstatus, this.state.searchTerm)}
                    </span>
                  </div>}
                </>
              )}

              <div className="UI-detail-row">
                <span className="UI-detail-label">Tax Amount</span>
                <span className="UI-detail-value">
                  {(() => {
                    const primaryTax = this.getPrimaryAmount(selectedInvoice, 'taxamount', 'cctaxamount');
                    const fallbackTax = this.getFallbackAmount(selectedInvoice, 'taxamount', 'cctaxamount');
                    return this.formatCurrencyWithConversion(
                      primaryTax,
                      fallbackTax,
                      selectedInvoice.currency,
                      selectedInvoice.curconversionrate,
                      currency,
                      '#4d4d4d',
                      this.state.searchTerm
                    );
                  })()}
                </span>
              </div>
            </div>

            {/* Additional Details */}
            <div className="UI-detail-section">
              <h3 className="UI-section-title">Additional Details</h3>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Invoice Type</span>
                <span className="UI-detail-value">{this.highlightSearchText(selectedInvoice.invtype, this.state.searchTerm)}</span>
              </div>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Delivery Status</span>
                <span className="UI-detail-value">{this.highlightSearchText(selectedInvoice.deliverystatus, this.state.searchTerm)}</span>
              </div>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Payment Status</span>
                <span className="UI-detail-value">{this.highlightSearchText(selectedInvoice.payment, this.state.searchTerm)}</span>
              </div>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Approval Status</span>
                <span className="UI-detail-value">{this.highlightSearchText(selectedInvoice.approvestatus, this.state.searchTerm)}</span>
              </div>
              {(selectedInvoice.agent || selectedInvoice.agentid || selectedInvoice.agentphno) && (
                <>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Agent</span>
                    <span className="UI-detail-value">{this.highlightSearchText(selectedInvoice.agent || 'N/A', this.state.searchTerm)}</span>
                  </div>
                  {selectedInvoice.agentid && (
                    <div className="UI-detail-row">
                      <span className="UI-detail-label">Agent ID</span>
                      <span className="UI-detail-value">{this.highlightSearchText(selectedInvoice.agentid, this.state.searchTerm)}</span>
                    </div>
                  )}
                  {selectedInvoice.agentphno && (
                    <div className="UI-detail-row">
                      <span className="UI-detail-label">Agent Phone</span>
                      <span className="UI-detail-value">{this.highlightSearchText(selectedInvoice.agentphno, this.state.searchTerm)}</span>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const isMobile = this.state.isMobile;

    return (
      <div className={`UI-container ${isMobile ? 'UI-container-mobile' : ''}`}>
        <div className="UI-card">
          {/* Header */}
          <div className={`UI-header ${isMobile ? 'UI-header-mobile' : ''}`}>
            <Breadcrumb breadcrumbs={[{ name: "Home", path: "/sales" }, { name: "Sales Invoices", path: null }]} />

            {/* <nav className={`UI-breadcrumb ${isMobile ? 'UI-breadcrumb-mobile' : ''}`}>
              <Link
                to="/sales"
                className={`UI-breadcrumb-item ${this.state.hovered === 'home' ? 'UI-breadcrumb-item-hover' : ''}`}
                onMouseEnter={() => this.setState({ hovered: 'home' })}
                onMouseLeave={() => this.setState({ hovered: null })}
              >
                Home
              </Link>
              <span>/</span>
              <span className={`UI-breadcrumb-item UI-breadcrumb-active`}>
                Sales Invoice
              </span>
            </nav> */}
            <div className={`UI-header-content ${isMobile ? 'UI-header-content-mobile' : ''}`}>
              <div>
                <h1 className={`UI-title ${isMobile ? 'UI-title-mobile' : ''}`}>Sales Invoices</h1>
                <p className={`UI-subtitle ${isMobile ? 'UI-subtitle-mobile' : ''}`}>
                  {this.state.currentView === 'detail' && this.state.selectedInvoice
                    ? `Overview`
                    : 'Manage your invoices and track payments'
                  }
                </p>
              </div>
              <div className={`UI-header-actions ${isMobile ? 'UI-header-actions-mobile' : ''}`}>
                {/* Desktop Search */}
                {!isMobile && (
                  <div
                    className={`UI-search-container ${this.state.showSearch ? 'UI-search-container-expanded' : ''} ${this.state.hovered === "search" ? 'UI-search-container-hover' : ''}`}
                    onClick={() => {
                      if (!this.state.showSearch) this.setState({ showSearch: true });
                    }}
                    onMouseEnter={() => this.setState({ hovered: "search" })}
                    onMouseLeave={() => this.setState({ hovered: null })}
                  >
                    <i className={`fa fa-search UI-search-icon ${this.state.hovered === "search" ? 'UI-search-container-hover' : ''}`} />
                    {!this.state.showSearch && "Search"}
                    {this.state.showSearch && (
                      <input
                        type="text"
                        className="UI-search-input"
                        placeholder="Search invoices..."
                        value={this.state.searchTerm}
                        onChange={(e) => this.handleSearch(e.target.value)}
                        autoFocus
                        onClick={(e) => e.stopPropagation()}
                        onBlur={() => {
                          if (this.state.searchTerm.trim() === "") {
                            this.setState({ showSearch: false });
                          }
                        }}
                      />
                    )}
                  </div>
                )}
                {/* Mobile Search */}
                {isMobile && (
                  <input
                    type="text"
                    className="UI-mobile-search-input"
                    placeholder="Search invoices..."
                    value={this.state.searchTerm}
                    onChange={(e) => this.handleSearch(e.target.value)}
                  />
                )}
                {/* Export dropdown */}
                {(salesid === "2" || salesid === "3") && (
                  <div className="UI-export-container" ref={this.exportRef}>
                    <button
                      className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-outline ${this.state.hovered === "export" ? 'UI-btn-outline-hover' : ''}`}
                      onClick={this.toggleExportDropdown}
                      onMouseEnter={() => this.setState({ hovered: "export" })}
                      onMouseLeave={() => this.setState({ hovered: null })}
                    >
                      <i className="fa fa-file-export" /> {isMobile ? "Export" : "Export"}
                      <i className="fa fa-caret-down" style={{ marginLeft: '4px' }} />
                    </button>
                    {this.state.exportDropdownOpen && (
                      <div className="UI-export-dropdown">
                        <button
                          className="UI-export-option"
                          onClick={this.exportPDF}
                          onMouseEnter={() => this.setState({ hovered: "exportPDF" })}
                          onMouseLeave={() => this.setState({ hovered: null })}
                        >
                          <i className="fa fa-file-pdf" /> PDF Export
                        </button>
                        <button
                          className="UI-export-option"
                          onClick={this.exportCSV}
                          onMouseEnter={() => this.setState({ hovered: "exportCSV" })}
                          onMouseLeave={() => this.setState({ hovered: null })}
                        >
                          <i className="fa fa-file-excel" /> CSV Export
                        </button>
                      </div>
                    )}
                  </div>
                )}
                {/* New Invoice button based on selected tab */}
                {(salesid === "2" || salesid === "3") && (this.state.type === "Tax Invoice" || this.state.type === "Proforma Invoice") && (
                  <Link
                    to={{ pathname: "/newsalesinvoice" }}
                    state={{
                      id: -1,
                      pagename: this.state.type === "Tax Invoice" ? "New Invoice" : "New Proforma Invoice"
                    }}
                    className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-primary ${this.state.hovered === "new" ? 'UI-btn-primary-hover' : ''}`}
                    style={{ textDecoration: "none" }}
                    onMouseEnter={() => this.setState({ hovered: "new" })}
                    onMouseLeave={() => this.setState({ hovered: null })}
                  >
                    <i className="fa fa-plus" />
                    {isMobile ? "New" : (this.state.type === "Tax Invoice" ? "New Invoice" : "New Proforma Invoice")}
                  </Link>
                )}
              </div>
            </div>
          </div>

          {this.state.loading ? (
            <div className="UI-loading-container">
              {spin}
            </div>
          ) : (
            <>
              {this.renderTypeTabs()}
              {this.renderStatusTabs()}
              <div style={{ marginTop: '8px' }}>
                {this.state.currentView === 'list'
                  ? this.renderTable()
                  : this.renderDetailView()
                }
              </div>
            </>
          )}
        </div>
      </div>
    )
  }
}

export default withRouter(InvoiceTable)